import { Box } from '@mui/system';

export function Help() {
    return (
        <Box
            sx={{
                float: 'left',
                textAlign: 'left',
                pl: 5,
                pr: 5,
                overflowY: 'auto',
            }}
        >
            <h1>Person and License Management Front-end</h1>
            <p>
        A front end website which will be known as Person and License
        Management, or PALM, for managing data in OEM is currently under
        development. This site will allow OPIS employees, such as customer
        service personnel and application developers, to manage licensing and
        access permissions for all OEM-enabled applications.
            </p>

            <h3>Architecture</h3>
            <p>
        We will be building PALM using React to power the UI alongside a middle
        tier service. React is being used due to its large community, prior
        usage at OPIS, easy template creation, and quick learning curve. The
        middle-tier service will be implemented with highly focused business
        logic Lambda functions written in Python and tied together using AWS API
        Gateway. The static front-end code and content will be served via
        S3-backed CloudFront.
                <br />
        In order to maintain an acceptable level of performance, the middle tier
        service will maintain a cache of various resources in a managed
        ElastiCache Redis cluster. These resources include, but may not be
        limited to, any information which must be gathered from sources outside
        of OPIS, such as profile information and search results from identity
        providers like AzureAD or SAM-IS.
                <br />
        For resources directly under our control, we plan to leverage
        CloudSearch to create a simple, intuitive searching workflow. When
        searching information that is external, we will use the search
        capabilities of those platforms as necessary.
            </p>

            <h3>Developer Workflow</h3>
            <span>
        Development will be carried out using our standard <i>git flow</i> development process:
                <ul>
                    <li>Long-living <i>development</i> and <i>main</i> branches </li>
                    <li>
            Pull Request check-list templates exist and are automatically
            applied, based on target branch, to every pull request
                    </li>
                    <ul>
                        <li>
              The submitter must attest that all items on the check-list have
              been completed before making a <i>non-draft</i> pull request
                        </li>
                    </ul>
                    <li>
            We will have a medium-lived story branch for each User Story for
            staging changes before merging to develop
                    </li>
                    <li>
            Only direct OPIS employees can approve pull requests into a
            long-living branch
                    </li>
                    <li>Commit messages <i>must</i> follow conventional commit syntax</li>
                    <ul>
                        <li>
              This will aid our automatic versioning and change log generation
                        </li>
                    </ul>
                </ul>
            </span>

            <h3> Releases </h3>
            <span>
        Releases will occur with our regular cadence, and a few new improvements
        to our standard process:
                <ul>
                    <li>
            Release once per sprint, each Wednesday following Sprint Review
                    </li>
                    <li>Change log will be automatically updated</li>
                    <li>Semantic version will be automatically applied</li>
                    <li>
            Documentation will be represented as code and updated via pipeline
                    </li>
                    <li>
            In order to ease transition periods, API stages will be versioned by
            major version number
                    </li>
                </ul>
            </span>

            <h3> Testing </h3>
            <span>
        To assure quality releases, robust automated and manual test strategies
        will be applied from the beginning
                <ul>
                    <li>
            Code must have unit tests with a line-level coverage o 80% or higher
                    </li>
                    <ul>
                        <li>
              The pipeline will automatically run unit tests and report this
              coverage
                        </li>
                    </ul>
                    <li>JavaScript will be unit tested using Vitest</li>
                    <li>Python will be unit tested with pytest</li>
                    <li>
            Middle-tier integration tests should cover every API Gateway route
                    </li>
                    <ul>
                        <li>These tests can be implemented in Postman.</li>
                        <li>
              Initially these tests will be manually run, but may be automated
              in the future.
                        </li>
                    </ul>
                    <li>End-to-end tests will be created in Playwright</li>
                    <ul>
                        <li>
              Initially these tests will be manually run, but may be automated
              in the future.
                        </li>
                    </ul>
                    <li>
            Locust.io load testing will be performed at expected usage levels
                    </li>
                    <ul>
                        <li>
              For PALM in particular, we expect a low amount of simultaneous
              users since it is meant for OPIS employees only
                        </li>
                    </ul>
                </ul>
            </span>
        </Box>
    );
}
